import { FC, useEffect, useState } from 'react';

import { DrawerSection } from 'components/drawerSections/DrawerSections';
import RaaTextAreaField from 'components/fieldComponents/raaTextAreaField/RaaTextAreaField';
import EgenskaperWithTagList from 'components/utkast/egenskaperWithTagList/EgenskaperWithTagList';

import { BebyggelseobjektDomaner, BebyggelseobjektUtkast, Egenskap } from 'models';

interface BeskrivningSectionProps {
  utkastData: BebyggelseobjektUtkast;
  domaner: BebyggelseobjektDomaner;
  showEgenskaper: boolean;
}

const BeskrivningSection: FC<BeskrivningSectionProps> = ({ utkastData, domaner, showEgenskaper }) => {
  const [selectedEgenskaper, setSelectedEgenskaper] = useState<Array<Egenskap>>([]);

  useEffect(() => {
    if (utkastData?.egenskaper) {
      setSelectedEgenskaper(utkastData.egenskaper);
    }
  }, [utkastData]);

  return (
    <DrawerSection>
      <fieldset>
        <legend className="tw-heading-md tw-mb-4">Beskrivning</legend>
        <RaaTextAreaField
          label="beskrivning"
          labelClass="tw-sr-only"
          classString="tw-h-[500px] raa-textarea"
          name="beskrivning"
        />
        {showEgenskaper && (
          <EgenskaperWithTagList
            egenskaper={domaner.egenskaper}
            selectedEgenskaper={selectedEgenskaper}
            setSelectedEgenskaper={setSelectedEgenskaper}
          />
        )}
      </fieldset>
    </DrawerSection>
  );
};

export default BeskrivningSection;
